import script from "./BaseButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseButton.vue?vue&type=script&lang=ts&setup=true"

import "./BaseButton.vue?vue&type=style&index=0&id=101620d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101620d7"]])

export default __exports__